import MainLayout from "../MainLayout"
import DashboardItems from "./DashboardItems"

const DashboardTemplate = () => {
  return (
    <MainLayout>
      <DashboardItems />
    </MainLayout>
  )
}

export default DashboardTemplate
